<template>
  <!-- 加入文明 -->
  <section id="join" class="join">
    <div class="l-center">
      <h2 class="title"></h2>
      <!-- 文明信息展示 -->
      <div class="swiper" v-if="!joinedCiviInfo">
        <div ref="swiper" class="swiper-inner">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(_, n) of 3" :key="n">
              <div class="civi-info" v-for="item of civiList.slice(n * 5, (n + 1) * 5)" :key="item.id"
                :data-name="item.id" v-gtag:join="item.name" @click="join('open', { value: item })">
                <div :class="{ new: civiHover[item.id].new, 'civi-profile': true }" :style="{
                  '--civi-qizhi': `url(
                      ${require(`@/images/civi/${item.id}/qizhi.png`)}
                    )`,
                  '--civi-tag': `url(
                      ${require(`@/images/civi/${item.id}/tag.png`)}
                    )`,
                }">
                  <img :style="{
                    top: civiHover[item.id].top,
                    left: civiHover[item.id].left,
                    width: civiHover[item.id].size,
                    height: civiHover[item.id].size,
                  }" :src="civiHover[item.id].img ||
  require(`@/images/civi/${item.id}/model.png`)
  " alt="" />
                </div>
                <div data-type="button" class="civi-join"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-gtag:arrowLeft ref="prev" class="swiper-button-prev"></div>
        <div v-gtag:arrowRight ref="next" class="swiper-button-next"></div>
      </div>

      <!-- 加入的文明信息 -->
      <div class="civi-detail" :style="{
        backgroundImage: `url(${require('@/images/civi/' +
          joinedCiviInfo.id +
          '/bg.png')})`,
      }" v-else>
        <div class="already-joined ff--trajanpro-bold">
          {{ $locale.join.joined }}
        </div>
        <div class="left">
          <div class="civi-name text-ellipsis ff--trajanpro-bold">
            {{ joinedCiviInfo.name }}
          </div>
          <div class="joined-tag" :class="{ new: civiHover[joinedCiviInfo.id].new }">
            <img :src="require(`@/images/civi/${joinedCiviInfo.id}/tag.png`)" alt="" />
          </div>
          <div class="text power ff--trajanpro-bold">
            {{ $locale.join.totalPower }}:
            {{ joinedCiviInfo.guild_power | emptyValueDisplay }}
          </div>
          <div class="text ff--trajanpro-bold">
            {{ $locale.join.totalPlayers }}:
            {{ joinedCiviInfo.guild_count | emptyValueDisplay }}
          </div>
        </div>
        <div class="right">
          <div class="table-title ff--trajanpro-bold">
            {{ $locale.join.table.title }}
          </div>
          <div class="table">
            <div class="thead">
              <div class="row">
                <div class="col">{{ $locale.join.table.ranking }}</div>
                <div class="col">{{ $locale.join.table.playerName }}</div>
                <div class="col">{{ $locale.join.table.playerUID }}</div>
                <div class="col">{{ $locale.join.table.powerContributed }}</div>
              </div>
            </div>
            <div class="tbody">
              <template v-if="all && all.length">
                <div class="row" v-for="(item, idx) of all" :key="item.id">
                  <div class="col">{{ idx + 1 }}</div>
                  <div class="col text-ellipsis" :title="item.uname">
                    {{ item.uname | emptyValueDisplay }}
                  </div>
                  <div class="col">{{ item.uuid | emptyValueDisplay }}</div>
                  <div class="col">{{ item.power | emptyValueDisplay }}</div>
                </div>
              </template>
              <div class="empty ff--trajanpro-bold" v-else>
                {{ $locale.toast.noRecord }}
              </div>
            </div>
            <div class="tfoot">
              <div class="row">
                <div class="col text-ellipsis">
                  {{ joinedCiviInfo.rank_by_guild || $locale.join.NotOnTheList }}
                </div>
                <div class="col text-ellipsis" :title="joinedCiviInfo.uname">
                  {{ joinedCiviInfo.uname | emptyValueDisplay }}
                </div>
                <div class="col">
                  {{ joinedCiviInfo.uuid | emptyValueDisplay }}
                </div>
                <div class="col">
                  {{ joinedCiviInfo.power | emptyValueDisplay }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="civi-profile">
          <img :src="require(`@/images/civi/${joinedCiviInfo.id}/model.png`)" alt="" />
        </div>
      </div>
    </div>

    <DlgJoin :id="civiId" :name="civiName" :visible="visible" @close="join('close')"
      @success="(data) => join('success')" />
  </section>
</template>

<script>
import cfgData from "scripts/constants/configData";
// 弹窗
import DlgJoin from "components/dialog/join.vue";
import { mapGetters, mapActions } from "vuex";
import { Px2rem } from "scripts/util";

export default {
  name: "Join",
  components: {
    DlgJoin,
  },
  data() {
    return {
      civiId: "",
      civiName: "",
      joinedCiviInfo: null,
      civiList: cfgData.civiList,
      civiHover: {
        arabia: { top: Px2rem("19px"), left: 0, size: "100%" },
        britain: { top: Px2rem("28px"), left: Px2rem("-15px"), size: "100%" },
        byzantium: {
          top: Px2rem("50px"),
          left: Px2rem("20px"),
          size: "80%",
          img: require(`@/images/civi/byzantium/model_right.png`),
        },
        china: { top: Px2rem("28px"), left: Px2rem("23px"), size: "90%" },
        egypt: { top: Px2rem("45px"), left: Px2rem("15px"), size: "80%" },
        france: { top: Px2rem("18px"), left: Px2rem("8px"), size: "90%" },
        germany: { top: Px2rem("28px"), left: Px2rem("17px"), size: "90%" },
        greece: {
          top: Px2rem("40px"),
          left: Px2rem("26px"),
          size: "80%",
          new: true,
        },
        japan: { top: Px2rem("12px"), left: Px2rem("20px"), size: "95%" },
        korea: { top: Px2rem("21px"), left: Px2rem("23px"), size: "85%" },
        ottomanEmpire: {
          top: Px2rem("27px"),
          left: Px2rem("32px"),
          size: "85%",
        },
        rome: { top: Px2rem("20px"), left: 0, size: "100%" },
        spain: { top: Px2rem("-8px"), left: 0, size: "100%" },
        vikings: { top: Px2rem("42px"), left: Px2rem("14px"), size: "85%" },
      },
      visible: false,
      all: [],
      isJoining: false,
    };
  },
  created() { },
  mounted() {
    new Swiper(this.$refs.swiper, {
      // spaceBetween: 10,
      // slidesPerView: 5,
      // slidesPerGroup: 5,
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
    });
  },
  beforeDestroy() {
    this.$login.$off("success");
  },
  watch: {
    userInfo: {
      handler(val) {
        const civiInfo = val?.user_info;
        if (!civiInfo) return;
        if (civiInfo.guild) {
          const civi = cfgData.civiList.find((i) => i.id == civiInfo?.guild);
          this.civiId = civiInfo.guild;
          this.civiName = civi?.name;
          this.joinedCiviInfo = Object.assign({}, civiInfo, civi, {
            uname: civiInfo.name,
            new: civiInfo?.guild == "greece",
          });

          // 获取个人战力排行榜
          this.getPersonalRankings();
        }
      },
      immediate: true,
    },
    isJoinCivi: {
      handler(val) {
        if (this.isJoining && !val) {
          this.join("open", {
            value: {
              id: this.civiId,
              name: this.civiName,
            },
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["isLogin", "userInfo", "isJoinCivi"]),
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    join(action, ...rest) {
      this.$message({
        message: this.$locale.toast.eventsEnded,
        duration: 3000,
      });
      return;

      const events = {
        open(opts = {}) {
          this.civiId = opts.value.id;
          this.civiName = opts.value.name;

          if (!this.isLogin) {
            this.$login.$emit("open");
            const loginSuccess = () => {
              this.isJoining = true;
            };
            const loginClose = () => {
              this.$login.$off("close", loginClose);
              this.$login.$off("success", loginSuccess);
            };
            // 监听登录成功
            this.$login.$on("success", loginSuccess);
            this.$login.$on("close", loginClose);
            return;
          }

          this.visible = true;
        },
        close() {
          this.visible = false;
          this.civiId = "";
          this.civiName = "";
          this.isJoining = false;
        },
        success() {
          this.isJoining = false;
          this.getUserInfo();
        },
      };
      events[action]?.apply(this, rest);
    },
    // 获取个人战力排行榜
    getPersonalRankings() {
      // 所有人的
      this.$req
        .getPersonalRankings({
          guild: this.civiId,
        })
        .then((res) => {
          console.log("all rankings", res.data);
          /* [{uuid: 30715, power: 290205965, updated_at: 1688022554}] */
          this.all = res.data || [];
        });
    },
  },
};
</script>

<style lang="less">
.join {
  height: 738px;

  .l-center {
    position: relative;
    width: 1380px;
    // overflow: hidden;
  }

  .title {
    margin: 12px 0 0;
    height: 77px;
    background: url(~images/title/join.png) no-repeat 0 center;
    background-size: 100% auto;
  }

  .swiper {
    overflow: auto;
  }

  .swiper-inner {
    position: relative;
    margin: 0 54px;
    overflow: hidden;
  }

  .swiper-slide {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 50px;
    height: 680px;
  }

  .swiper-button-prev {
    left: 0;
    width: 42px;
    height: 66px;
    background: url(~images/join/btn_prev.png) no-repeat 0 center;
    background-size: 100% 100%;
  }

  .swiper-button-next {
    right: 0;
    width: 42px;
    height: 66px;
    background: url(~images/join/btn_next.png) no-repeat 0 center;
    background-size: 100% 100%;
  }

  .swiper-button-prev,
  .swiper-button-next {
    margin-top: -33px;
  }

  .swiper-button-prev::after,
  .swiper-button-next::after {
    content: none;
  }

  .civi-info {
    flex-shrink: 0;
    position: relative;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: 0.3s;

    &:not(:last-child) {
      margin-right: -28px;
    }

    &:nth-child(even) {
      top: 125px;
    }

    &:hover {
      transform: scale(1.1);

      .civi-profile {
        &::after {
          opacity: 1;
        }
      }
    }
  }

  .new::before {
    content: "";
    position: absolute;
    top: -20px;
    right: 25%;
    width: 40px;
    height: 40px;
    background: url(~images/civi/new.png) no-repeat 0 0;
    background-size: 100% 100%;
  }

  .civi-profile {
    position: relative;
    width: 245px;
    height: 377px;
    transition: 0.3s;
    background: var(--civi-tag) no-repeat center top,
      var(--civi-qizhi) no-repeat center top,
      url(~images/civi/stage.png) no-repeat center bottom;
    background-size: 92px 61px, 252px 312px, 248px 58px;

    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: contain;
      z-index: 1;
    }

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url(~images/join/civi_light.png) no-repeat center 48px;
      background-size: 75%;
      opacity: 0;
      transition: 0.3s;
    }
  }

  .civi-join {
    position: relative;
    // top: 20px;
    width: 158px;
    height: 61px;
    background: url(~images/join/btn_join.png) no-repeat 0 center;
    background-size: 100% 100%;
  }

  .civi-detail {
    position: relative;
    margin: 50px auto 0;
    display: flex;
    padding: 50px 0 80px;
    width: 1159px;
    // height: 550px;
    background: no-repeat 0 0;
    background-size: 100% 100%;

    .already-joined {
      position: absolute;
      top: 20px;
      left: 57px;
      width: auto;
      height: 24px;
      padding: 0 10px;
      background-color: #612c14;
      border-radius: 12px;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      color: var(--primary-color);
    }

    .left {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 366px;
      padding: 30px 20px 0 60px;

      .civi-name {
        position: relative;
        max-width: 258px;
        width: 100%;
        padding: 0 40px;
        font-size: 33px;
        height: 40px;
        line-height: 37px;
        color: var(--primary-color);
        text-shadow: 1px 2px 0px rgba(57, 46, 32, 0.54),
          0px 0px 1px rgba(255, 233, 129, 0.69);
        vertical-align: middle;
        text-align: center;

        &::before,
        &::after {
          position: absolute;
          top: 8px;
          content: "";
          display: inline-block;
          width: 36px;
          height: 24px;
          background: url(~images/join/civi_name_icon_left.png) no-repeat 0 0;
          background-size: 100% auto;
        }

        &::before {
          left: 0;
        }

        &::after {
          right: 0;
          background-image: url(~images/join/civi_name_icon_right.png);
        }
      }

      .joined-tag {
        position: relative;
        width: 143px;
        height: 100px;
        margin: 20px 0;

        &.new::before {
          top: -10px;
          right: -10px;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .text {
        font-size: 15px;
        color: var(--primary-color);
        text-shadow: 1px 2px 0px rgba(57, 46, 32, 0.54),
          0px 0px 1px rgba(255, 233, 129, 0.69);
        word-break: keep-all;
        max-width: 280px;

        &.power {
          margin-bottom: 30px;
        }
      }
    }

    .right {
      padding-right: 186px;
      flex: 1;

      .table-title {
        margin-bottom: 10px;
        font-size: 33px;
        letter-spacing: 0px;
        color: var(--primary-color);
        text-align: center;
        text-shadow: 1px 2px 0px rgba(57, 46, 32, 0.54),
          0px 0px 1px rgba(255, 233, 129, 0.69);
      }
    }

    .civi-profile {
      position: absolute;
      bottom: -120px;
      right: -70px;
      width: 347px;
      height: 478px;

      img {
        object-fit: contain;
      }
    }

    .table {
      margin: 0;
      width: 607px;
      height: 312px;
      padding: 3px;
      background-image: url(~images/join/table_bg.png);

      .row {
        &:not(:last-child) {
          margin-bottom: 12px;
        }
      }

      .thead {
        height: 48px;

        .col {
          font-size: 16px;
          color: #724634;
          text-shadow: none;

          &:nth-child(1) {
            width: 124px;
          }

          &:nth-child(2) {
            width: 104px;
          }

          &:nth-child(3) {
            width: 149px;
          }

          &:nth-child(4) {
            width: 200px;
          }
        }
      }

      .tbody {
        padding: 14px;

        .row {
          height: 35px;
        }

        .col {
          padding: 0 6px;

          &:nth-child(1) {
            width: 110px;
          }

          &:nth-child(2) {
            width: 104px;
          }

          &:nth-child(3) {
            width: 155px;
          }

          &:nth-child(4) {
            width: 180px;
            padding-right: 40px;
          }
        }
      }

      .tfoot {
        .col {
          padding: 0 6px;

          &:nth-child(1) {
            width: 110px;
          }

          &:nth-child(2) {
            width: 104px;
          }

          &:nth-child(3) {
            width: 155px;
          }

          &:nth-child(4) {
            width: 180px;
            padding-right: 40px;
          }
        }
      }
    }
  }
}
</style>
